import Http from "../../service/api";

// -----------------------------  未登录时接口  -------------------------
/**
 * 未登录获取菜单下的类型和标签 get query
 * @param {*} params 
 */
export async function getNoTypetags(params: any) {
  return Http.get('/public/v1/typetags', params);
}
/**
 * 未登陆活动集合 get query
 * @param {*} params 
 */
export async function getNoActivityList(params: any) {
  return Http.get('/public/v1/campaign/list', params);
}
/**
 * 未登陆查询课程集合 get query
 * @param {*} params 
 */
export async function getNoCourseList(params: any) {
  return Http.get('/public/v1/curriculum/list', params);
}
/**
 * 外部用户获取考试集合 get query
 * @param {*} params 
 */
export async function getNoExamList(params: any) {
  return Http.get('/public/v1/exam/external/list', params);
}
/**
 * 外部用户查询证书 get query
 * @param {*} params 
 */
export async function getCertList(params: any) {
  return Http.get(`/public/v1/cert/list&`, params);
}

/**
 * 将用户信息传递给后端 put json
 * @param {*} params 
 */
 export async function sendUserSso(params: any) {
  return Http.put('/public/user/sso', params);
}
